var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsOptional, ValidateNested } from 'class-validator';
import { TreatmentPlanStatus } from '../enums/treatment-plan-status.enum.js';
import { AgreementDataDto } from './agreement-data.dto.js';
import { GkvInsuranceDataDto } from './gkv-insurance-data.dto.js';
import { PrescriptionDataDto } from './prescription-data.dto.js';
export class UpdateTreatmentPlanDto {
    status;
    validFrom;
    validUntil;
    prescriptionData;
    agreementData;
    /**
     * Patch for the eGK snapshot (#1503). Two levels, and they mean different
     * things: omitting this **block** (or sending `null`) leaves the card alone,
     * while a **field** inside it is written — including an explicit `null`, which
     * clears that field, because a Therapeut who mistyped an IK has to be able to
     * take it back. Refused outright on a non-GKV plan rather than dropped.
     */
    gkvInsuranceData;
}
__decorate([
    Expose(),
    IsEnum(TreatmentPlanStatus),
    IsOptional(),
    __metadata("design:type", String)
], UpdateTreatmentPlanDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTreatmentPlanDto.prototype, "validFrom", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTreatmentPlanDto.prototype, "validUntil", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => PrescriptionDataDto),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTreatmentPlanDto.prototype, "prescriptionData", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => AgreementDataDto),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTreatmentPlanDto.prototype, "agreementData", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => GkvInsuranceDataDto),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateTreatmentPlanDto.prototype, "gkvInsuranceData", void 0);
//# sourceMappingURL=update-treatment-plan.dto.js.map